import script from "./ViewClientDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewClientDocuments.vue?vue&type=script&setup=true&lang=js"

import "./ViewClientDocuments.vue?vue&type=style&index=0&id=58b3cb0c&lang=scss&scoped=true"
import "./ViewClientDocuments.vue?vue&type=style&index=1&id=58b3cb0c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b3cb0c"]])

export default __exports__